import { render, staticRenderFns } from "./RingProgress.vue?vue&type=template&id=61c364e4&scoped=true"
import script from "./RingProgress.vue?vue&type=script&lang=js"
export * from "./RingProgress.vue?vue&type=script&lang=js"
import style0 from "./RingProgress.vue?vue&type=style&index=0&id=61c364e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c364e4",
  null
  
)

export default component.exports